/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


define('modules/Cart/all',[
    'global/all',
    './Cart',
    './CartItems',
    './CartManager',
    './CartRailSummary',
    './CartSavedItems',
    './CartSummary',
    './CartTools',
    './CartLocker' // passign cart locker per quotes customization
], function (Roc, Cart, CartItems, CartManager, CartRailSummary, CartSavedItems, CartSummary, CartTools, CartLocker) {
    Roc.Logger.debug('Loaded Cart Module and all dependencies.');

    Cart.Core = Cart;
    Cart.CartItems = CartItems;
    Cart.CartManager = CartManager;
    Cart.CartRailSummary = CartRailSummary;
    Cart.CartSavedItems = CartSavedItems;
    Cart.CartSummary = CartSummary;
    Cart.CartTools = CartTools;
    // Quotes
    Cart.CartLocker = CartLocker;
    // EO Quotes
    return Cart;
});

